import React, { Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";
import Loading from "../components/loading";
import AdminLayout from "../components/layouts/admin_layout";
import UserLayout from "../components/layouts/user_layout";
import AdminRoute from "./admin_route";
import AuthRoute from "./auth_route";

const lazyPage = (importPage) => lazy(importPage);

const Dashboard = lazyPage(() => import("../pages/dashboard"));
const Transfers = lazyPage(() => import("../pages/transfers"));
const VietcombankTransfer = lazyPage(
  () => import("../pages/transfers/vietcombank"),
);
const VietcombankPriorityTransfer = lazyPage(
  () => import("../pages/transfers/vietcombankPriority"),
);
const TechcombankTransfer = lazyPage(
  () => import("../pages/transfers/techcombank"),
);
const BIDVTransfer = lazyPage(() => import("../pages/transfers/bidv"));
const SacombankTransfer = lazyPage(
  () => import("../pages/transfers/sacombank"),
);
const VietinbankTransfer = lazyPage(
  () => import("../pages/transfers/vietinbank"),
);
const MSBTransfer = lazyPage(() => import("../pages/transfers/msb"));
const VpbankTransfer = lazyPage(() => import("../pages/transfers/vpbank"));
const MomoTransfer = lazyPage(() => import("../pages/transfers/momo"));
const MBBankTransfer = lazyPage(() => import("../pages/transfers/mbbank"));
const AgribankTransfer = lazyPage(() => import("../pages/transfers/agribank"));
const TPBankTransfer = lazyPage(() => import("../pages/transfers/tpbank"));
const ACBTransfer = lazyPage(() => import("../pages/transfers/acb"));
const OCBTransfer = lazyPage(() => import("../pages/transfers/ocb"));
const DongABankTransfer = lazyPage(
  () => import("../pages/transfers/dongabank"),
);
const PVComBankTransfer = lazyPage(
  () => import("../pages/transfers/pvcombank"),
);
const NamABankTransfer = lazyPage(() => import("../pages/transfers/namabank"));
const SeABankTransfer = lazyPage(() => import("../pages/transfers/seabank"));
const LPBankTransfer = lazyPage(() => import("../pages/transfers/lpbank"));
const BVBankTransfer = lazyPage(() => import("../pages/transfers/bvbank"));
const VIBTransfer = lazyPage(() => import("../pages/transfers/vib"));
const SHBTransfer = lazyPage(() => import("../pages/transfers/shb"));
const HDBankTransfer = lazyPage(() => import("../pages/transfers/hdbank"));
const KienlongBankTransfer = lazyPage(
  () => import("../pages/transfers/kienlongbank"),
);
const ABBankTransfer = lazyPage(() => import("../pages/transfers/abbank"));
const EximbankTransfer = lazyPage(() => import("../pages/transfers/eximbank"));
const BacABankTransfer = lazyPage(() => import("../pages/transfers/bacabank"));
const NCBTransfer = lazyPage(() => import("../pages/transfers/ncb"));
const SaigonbankTransfer = lazyPage(
  () => import("../pages/transfers/saigonbank"),
);
const ShinhanBankTransfer = lazyPage(
  () => import("../pages/transfers/shinhanbank"),
);
const CakeTransfer = lazyPage(() => import("../pages/transfers/cake"));
const TimoTransfer = lazyPage(() => import("../pages/transfers/timo"));
const VikkiTransfer = lazyPage(() => import("../pages/transfers/viki"));
const ViettelTransfer = lazyPage(() => import("../pages/transfers/viettel"));

const Transactions = lazyPage(() => import("../pages/transactions"));
const VietcombankTransaction = lazyPage(
  () => import("../pages/transactions/vietcombank"),
);
const TechcombankTransaction = lazyPage(
  () => import("../pages/transactions/techcombank"),
);
const Bidv = lazyPage(() => import("../pages/transactions/bidv"));
const Acb = lazyPage(() => import("../pages/transactions/acb"));
const Agribank = lazyPage(() => import("../pages/transactions/agribank"));
const Mbbank = lazyPage(() => import("../pages/transactions/mbbank"));
const Viettinbank = lazyPage(() => import("../pages/transactions/viettinbank"));

const Balances = lazyPage(() => import("../pages/balances"));
const ACBBalance = lazyPage(() => import("../pages/balances/acb"));
const AgribankBalance = lazyPage(() => import("../pages/balances/agribank"));
const MBBankBalance = lazyPage(() => import("../pages/balances/mb"));
const TechcombankBalance = lazyPage(
  () => import("../pages/balances/techcombank"),
);
const TPBankBalance = lazyPage(() => import("../pages/balances/tpbank"));
const VietcombankBalance = lazyPage(
  () => import("../pages/balances/vietcombank"),
);
const VPBankBalance = lazyPage(() => import("../pages/balances/vpbank"));
const BIDVBalance = lazyPage(() => import("../pages/balances/bidv"));
const VietinBalance = lazyPage(() => import("../pages/balances/vietinbank"));

const SMS = lazyPage(() => import("../pages/sms"));
const TPBankSMS = lazyPage(() => import("../pages/sms/tpbank"));

const SMSNotification = lazyPage(() => import("../pages/sms-notifications"));

const Admin = lazyPage(() => import("../pages/admin"));
const UserManagement = lazyPage(() => import("../pages/admin/user_management"));
const RoleManagement = lazyPage(() => import("../pages/admin/role_management"));
const Login = lazyPage(() => import("../pages/login"));
const ErrorPage = lazyPage(() => import("../pages/error"));

const userRouteGroups = [
  {
    path: "/",
    indexComponent: Dashboard,
  },
  {
    path: "transfers",
    indexComponent: Transfers,
    children: [
      { path: "vietcombank", component: VietcombankTransfer },
      { path: "vietcombankPriority", component: VietcombankPriorityTransfer },
      { path: "techcombank", component: TechcombankTransfer },
      { path: "bidv", component: BIDVTransfer },
      { path: "sacombank", component: SacombankTransfer },
      { path: "vietinbank", component: VietinbankTransfer },
      { path: "msb", component: MSBTransfer },
      { path: "vpbank", component: VpbankTransfer },
      { path: "momo", component: MomoTransfer },
      { path: "mbbank", component: MBBankTransfer },
      { path: "agribank", component: AgribankTransfer },
      { path: "tpbank", component: TPBankTransfer },
      { path: "acb", component: ACBTransfer },
      { path: "ocb", component: OCBTransfer },
      { path: "dongabank", component: DongABankTransfer },
      { path: "pvcombank", component: PVComBankTransfer },
      { path: "namabank", component: NamABankTransfer },
      { path: "seabank", component: SeABankTransfer },
      { path: "lpbank", component: LPBankTransfer },
      { path: "bvbank", component: BVBankTransfer },
      { path: "vib", component: VIBTransfer },
      { path: "shb", component: SHBTransfer },
      { path: "hdbank", component: HDBankTransfer },
      { path: "kienlongbank", component: KienlongBankTransfer },
      { path: "abbank", component: ABBankTransfer },
      { path: "eximbank", component: EximbankTransfer },
      { path: "bacabank", component: BacABankTransfer },
      { path: "ncb", component: NCBTransfer },
      { path: "saigonbank", component: SaigonbankTransfer },
      { path: "shinhanbank", component: ShinhanBankTransfer },
      { path: "cake", component: CakeTransfer },
      { path: "timo", component: TimoTransfer },
      { path: "viki", component: VikkiTransfer },
      { path: "viettel", component: ViettelTransfer },
    ],
  },
  {
    path: "transactions",
    indexComponent: Transactions,
    children: [
      { path: "vietcombank", component: VietcombankTransaction },
      { path: "techcombank", component: TechcombankTransaction },
      { path: "bidv", component: Bidv },
      { path: "acb", component: Acb },
      { path: "agribank", component: Agribank },
      { path: "mbbank", component: Mbbank },
      { path: "viettinbank", component: Viettinbank },
    ],
  },
  {
    path: "balances",
    indexComponent: Balances,
    children: [
      { path: "acb", component: ACBBalance },
      { path: "agribank", component: AgribankBalance },
      { path: "mbbank", component: MBBankBalance },
      { path: "techcombank", component: TechcombankBalance },
      { path: "tpbank", component: TPBankBalance },
      { path: "vietcombank", component: VietcombankBalance },
      { path: "vpbank", component: VPBankBalance },
      { path: "bidv", component: BIDVBalance },
      { path: "vietin", component: VietinBalance },
    ],
  },
  {
    path: "sms",
    indexComponent: SMS,
    children: [{ path: "tpbank", component: TPBankSMS }],
  },
  {
    path: "sms-notifications",
    indexComponent: SMSNotification,
  },
];

const adminRouteGroup = {
  path: "admin",
  indexComponent: Admin,
  children: [
    { path: "user-management", component: UserManagement },
    { path: "role-management", component: RoleManagement },
  ],
};

function GuardedPage({ Guard, Component }) {
  return (
    <Guard>
      <Component />
    </Guard>
  );
}

function renderIndexRoute(Component, Guard) {
  return (
    <Route
      index
      element={<GuardedPage Guard={Guard} Component={Component} />}
    />
  );
}

function renderChildRoute(route, Guard) {
  return (
    <Route
      key={route.path}
      path={route.path}
      element={<GuardedPage Guard={Guard} Component={route.component} />}
    />
  );
}

function renderRouteGroup(routeGroup, Guard) {
  const { path, indexComponent, children = [] } = routeGroup;

  return (
    <Route key={path} path={path}>
      {renderIndexRoute(indexComponent, Guard)}
      {children.map((child) => renderChildRoute(child, Guard))}
    </Route>
  );
}

export default function Router() {
  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        <Route element={<UserLayout />}>
          {userRouteGroups.map((routeGroup) =>
            renderRouteGroup(routeGroup, AuthRoute),
          )}
        </Route>

        <Route element={<AdminLayout />}>
          {renderRouteGroup(adminRouteGroup, AdminRoute)}
        </Route>

        <Route path="login" element={<Login />} />
        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </Suspense>
  );
}
